import { PaginationPcApiResponse } from '@/api/pc-api/types';
import { BizTargetType } from '@/constants/bizTargetType';
import { DEFAULT_PAGE_SIZE } from '@/constants/pagination';
import { Role } from '@/constants/role';
import { PREFIX_PATH } from '@/lib/axios/axiosInterceptor';
import { api } from '@/utils/api';

export type UserInfo = {
  email: string;
  id: string; // NOTE: user Id
  name: string;
  role: Role;
  bizTargetType: BizTargetType;
  registeredAt?: string;
  invitedAt?: string;
  isInviting: boolean;
  isLoggedInUser: boolean;
  inviteUrl?: string;
};

type Args = {
  page: number;
  size?: number;
  partnerId: string;
};

export const getUserList = ({ page, size = DEFAULT_PAGE_SIZE, partnerId }: Args) => {
  return api<PaginationPcApiResponse<UserInfo[]>>('get', `/pc-api/v1/${PREFIX_PATH}/partner/user/list`, {
    partnerId,
    size,
    page
  });
};
